import { IPAGE } from '@/types/base.d';
import fetch from './index';

// 获取用户列表
const getUser = (params: IPAGE, type: number, title: any) => fetch.axios_admin.get(`/user/page?type=${type}&title=${title}`, { params });

// 重置密码功
const resetPass = (pid: string) => fetch.axios_admin.put(`/user/userPass/${pid}`);

// 修改用户状态
const editStatus = (pid: string, status: number) => fetch.axios_admin.put(`/user/userStatus?pid=${pid}&status=${status}`);

// 查询用户线下课程
const getCourseById = (pid: string) => fetch.axios_admin.get(`/user/course/${pid}`);

// 查询用户上课进度
const getAttendSchedule = (uid: string, ccId: string) => fetch.axios_admin.get(`/user/attendSchedule?uid=${uid}&ccId=${ccId}`);

// 查询查询用户章节作品
const getProject = (uid: string, chapterId: string, type: string) => fetch.axios_admin.get(`user/userProject?uid=${uid}&chapterId=${chapterId}&type=${type}`);

// 查询用户其他作品
const getOtherProject = (params: IPAGE, uid: string, courseType: string, title: string, status: string) => fetch.axios_admin.get(`user/userElseWorks?uid=${uid}&courseType=${courseType}&title=${title}&status=${status}`, { params });

// 查询课程作品分类
const getWorksType = () => fetch.axios_admin.get('user/worksType');

// 查询作品评论
const getProjectComment = (params: IPAGE, projectId: string) => fetch.axios_admin.get(`project/comment?pageNo=${params.pageNo}&pageSize=${params.pageSize}&projectId=${projectId}`);

// 删除评论
const deleteComment = (commentId: string) => fetch.axios_admin.put(`project/comment?pid=${commentId}`);

// 查询作品审核状态
const getProjectStatus = (projectId: string) => fetch.axios_admin.get(`project/status?projectId=${projectId}`)

export default {
  getUser,
  resetPass,
  editStatus,
  getCourseById,
  getAttendSchedule,
  getProject,
  getOtherProject,
  getWorksType,
  getProjectComment,
  deleteComment,
  getProjectStatus,
};
